import { render, staticRenderFns } from "./ArrowLeft.vue?vue&type=template&id=574332dc&"
import script from "./ArrowLeft.vue?vue&type=script&lang=js&"
export * from "./ArrowLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('574332dc')) {
      api.createRecord('574332dc', component.options)
    } else {
      api.reload('574332dc', component.options)
    }
    module.hot.accept("./ArrowLeft.vue?vue&type=template&id=574332dc&", function () {
      api.rerender('574332dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/ArrowLeft.vue"
export default component.exports